/** Extracts a filename (with extension) from a URL path, decoded; null if none. */
export const extractFilename = (url: string): string | null => {
  try {
    const parsedUrl = new URL(url);
    const segments = parsedUrl.pathname.split('/').filter(Boolean);
    const filename = segments.find((segment) =>
      /\.[a-zA-Z0-9]+$/.test(segment)
    );
    return filename ? decodeURIComponent(filename) : null;
  } catch {
    return null;
  }
};
